export interface Environment {
  production: boolean;
  generales: {
    rootUseCaseId?: number;
    inactivityToleration: number;
    activityTolerationTime: number,
  }
  apiUrl: string;
  keyCrypt: string;
  urlBaseBackEnd: string;
  login: string;
  azure: {
    clientId: string;
    authority: string;
    redirectUri: string;
    clientSecret: string;
    tenantId: string;
    postLogoutRedirectUri: string;
  };
  userImageToken: string;
}

export const environment: Environment = {
  production: false,
  generales: {
    rootUseCaseId: 535,
    inactivityToleration: 5000,
    activityTolerationTime: 10000,
  },
  azure: {
    clientId: 'TU_ID_DE_CLIENTE',
    authority: 'https://login.microsoftonline.com/TENANT_ID',
    redirectUri: 'http://localhost:4200',
    clientSecret: 'TU_CLIENT_SECRET',
    tenantId: 'TU_TENANT_ID',
    postLogoutRedirectUri: ' http://localhost:4200/login',
  },
  apiUrl: 'https://sied.uqroo.mx',
  keyCrypt: 'SIGEDO-2024-K3Y&',
  urlBaseBackEnd: 'https://sied-back.uqroo.mx/api/v1',
  //urlBaseBackEnd: 'http://localhost:8081/api/v1',
  
  login: 's',
  userImageToken: 'TOKEN_IMAGEN_USUARIO_API.',
};

export enum Modules {
  AUTH = 'auth',
  LOGIN = 'authenticate',
  USERS = 'users',
  DOCS = 'document',
  FILE = 'fileManager',
  INFO = 'info',
  AUTOCONFIG = 'auto-config',
  GENERATOR = 'generator',
  GENERATORMODULE = 'frame/modulos',
  GENERATORREADER = 'generator-reader',
  NAMEAPI = 'api',
  APPLICATIONS = 'applications',
  USER = 'user',
}

export const URLs = {
  minio: `${environment.urlBaseBackEnd}/minio-files`,
  autoConfigController: `${environment.urlBaseBackEnd}/${Modules.AUTOCONFIG}/generales`,
  auth: `${environment.urlBaseBackEnd}/${Modules.AUTH}`,
  authRoles: `${environment.urlBaseBackEnd}/${Modules.AUTH}/roles`,
  loginMicrisoft: `${environment.urlBaseBackEnd}/o365`,
  info: `${environment.urlBaseBackEnd}/${Modules.INFO}`,
  login: `${environment.urlBaseBackEnd}/${Modules.AUTH}/${Modules.LOGIN}`,
  refreshToken: `${environment.urlBaseBackEnd}/${Modules.AUTH}/refresh-token`,
  document: `${environment.urlBaseBackEnd}/${Modules.DOCS}`,
  file: `${environment.urlBaseBackEnd}/${Modules.NAMEAPI}/${Modules.FILE}`,
  generator: `${environment.urlBaseBackEnd}/${Modules.GENERATOR}`,
  generatorReader: `${environment.urlBaseBackEnd}/${Modules.GENERATORREADER}`,
  ngenerator: `${environment.urlBaseBackEnd}/${Modules.GENERATOR}`,
  generatorModule: `${environment.urlBaseBackEnd}/${Modules.GENERATORMODULE}`,
  applications: `${environment.urlBaseBackEnd}/${Modules.APPLICATIONS}`,
  menu: `${environment.urlBaseBackEnd}/${Modules.USER}/menu`,
  useCases: `${environment.urlBaseBackEnd}/${Modules.USER}/usecases`,
  allUseCases: `${environment.urlBaseBackEnd}/${Modules.USER}/usecases/all`,
  systemUseCases: `${environment.urlBaseBackEnd}/${Modules.USER}/system`,
  useCasesByParent: `${environment.urlBaseBackEnd}/${Modules.USER}/useCasesByParent`,
  evUsers: `${environment.urlBaseBackEnd}/ev-users`,
  evEmpleado: `${environment.urlBaseBackEnd}/ev-empleado`,
  evQuizz: `${environment.urlBaseBackEnd}/ev-quizz`,
  mailPlantillas: `${environment.urlBaseBackEnd}/mail-plantillas`,
  evCaspectos: `${environment.urlBaseBackEnd}/ev-caspectos`,
  evCtquizz: `${environment.urlBaseBackEnd}/ev-ctquizz`,
  users: `${environment.urlBaseBackEnd}/${Modules.USERS}`,
  homepageAccess: `${environment.urlBaseBackEnd}/generator/InicioAccesos`,
  casofluex: `${environment.urlBaseBackEnd}/fluex`,
  rolUseCase: `${environment.urlBaseBackEnd}/rolcase`,
  spdb: `${environment.urlBaseBackEnd}/spdb`,
  dashboardGenerator: `${environment.urlBaseBackEnd}/dashboardGenerator`,
  inputsTypes: `${environment.urlBaseBackEnd}/input-types`,
  inputsProperties: `${environment.urlBaseBackEnd}/input-types/properties`,
  displayModes: `${environment.urlBaseBackEnd}/input-types/display-modes`,
  evPeriodo:    `${environment.urlBaseBackEnd}/ev-periodo`,
  evCiclo:      `${environment.urlBaseBackEnd}/ev-periodo/ciclos`,
  evCquestions: `${environment.urlBaseBackEnd}/ev-cquestions`,
  evFirmas:     `${environment.urlBaseBackEnd}/ev-firmas`,
  evUbcOmitidas: `${environment.urlBaseBackEnd}/ev-ubc-omitidas`,
  constanciaTextos: `${environment.urlBaseBackEnd}/constancia-textos`,
  usuariosRoles:    `${environment.urlBaseBackEnd}/usuarios-roles`,
  periodoRecordatorios: `${environment.urlBaseBackEnd}/periodo-recordatorios`,
  constanciaPublica: `${environment.urlBaseBackEnd}/constancia-publica`,
};
